import { Button } from 'react-bootstrap';
import { getTeamTricode } from './utils';
import styles from './SessionSetup.module.css';

export function PendingChangesBanner({
  sessionTeams,
  sessionRosters,
  squads,
  pendingSquads,
  applying,
  onApply,
  onCancel,
}) {
  // Calculate preview of new order
  // First, collect all squad names to create sequential ordering (0, 1, 2, ...)
  // This handles cases like squads A, B, D being assigned (should be orders 0, 1, 2, not 0, 1, 3)
  const teamSquadInfo = sessionTeams.map((st) => {
    const sr = sessionRosters.find((r) => r.roster?.team?.id === st.team?.id);
    const currentSquad = squads.find((s) => s.id === sr?.squadId);
    const pendingSquadName = sr ? pendingSquads[sr.id] : null;
    const finalSquadName = pendingSquadName || currentSquad?.name || 'Z';
    const tricode = st.team?.triCode || getTeamTricode(st.team?.name);
    return {
      tricode,
      squadName: finalSquadName,
      isPending: !!pendingSquadName,
    };
  });

  // Get unique squad names sorted alphabetically, then create sequential mapping
  const usedSquads = [...new Set(teamSquadInfo.map((t) => t.squadName))].sort();
  const squadToOrder = Object.fromEntries(
    usedSquads.map((squad, idx) => [squad, idx])
  );

  const previewOrder = teamSquadInfo
    .map((item) => ({
      ...item,
      newOrder: squadToOrder[item.squadName],
    }))
    .sort((a, b) => a.newOrder - b.newOrder);

  return (
    <div className={styles.pendingBanner}>
      <div className={styles.pendingInfo}>
        <strong>New Order:</strong>
        {previewOrder.map((item, idx) => (
          <span
            key={idx}
            className={styles.pendingItem}
            style={
              item.isPending
                ? { background: '#fef3c7', borderColor: '#f59e0b' }
                : {}
            }
          >
            {idx + 1}. {item.tricode} ({item.squadName})
          </span>
        ))}
      </div>
      <div className={styles.pendingActions}>
        <Button
          size="sm"
          variant="outline-secondary"
          onClick={onCancel}
          disabled={applying}
        >
          Cancel
        </Button>
        <Button
          size="sm"
          variant="primary"
          onClick={onApply}
          disabled={applying}
        >
          {applying ? 'Applying...' : 'Apply Changes'}
        </Button>
      </div>
    </div>
  );
}
